import { SVG } from './esveegee.js'

import { Colors } from './colors.js'

export const diagram = (s: SVG) => {
    s.size(600, 300)

    const nodes = [
        { x: 16, y: 0 },
        { x: 300, y: 90 },
        { x: 16, y: 175 }
    ]

    const connections = [
        { from: nodes[0], to: nodes[1] },
        { from: nodes[1], to: nodes[2] }
    ]

    // connections first (z!)
    for (const [index, connection] of connections.entries()) {
        const [x, y, x1, y1, x2, y2] = [
            connection.from.x + 75,
            connection.from.y + 60,
            connection.from.x,
            connection.from.y,
            connection.to.x,
            connection.to.y
        ]

        s.group(x, y)
            .line(x1, y1, x2, y2)
            .text(`line ${index}`, (x1 + x2) / 2 , (y1 + y2) / 2).fill(Colors.SeaBlue)
                .align('middle').verticalAlign('middle')
    }

    // nodes on top
    for (const [index, node] of nodes.entries()) {
        const html = `
<table>
 <caption>table ${index}</caption>
 <tr><th>Column</th><th>Type</th></tr>
 <tr><td>Column1</td><td>Type1</td></tr>
 <tr><td>Column2</td><td>Type2</td></tr>
</table>
`
        s.html(html, node.x, node.y).draggable()
    }
}
